import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Grid,
  Chip,
  Box,
} from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";
import color from "../../Constants/colors";
import { SingleCertificationResponse } from "../../Models/certification";
import { useTranslation } from "react-i18next";

const CertCategoryModal = ({
  open,
  onClose,
  certCategory,
  isLoading,
}: {
  open: boolean;
  onClose: () => void;
  certCategory: SingleCertificationResponse | null;
  isLoading: boolean;
}) => {
  const { t } = useTranslation("modal");

  if (isLoading) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    );
  }

  if (!certCategory) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent
        sx={{
          overflowY: "auto",
          padding: "2rem",
          color: color.white,
        }}
      >
        <Box
          component="img"
          src="/commo_logo.png"
          alt={t("certification_logo_alt")}
          sx={{
            position: "absolute",
            top: "20px",
            left: "16px",
            width: "auto",
            height: "50px",
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              sx={{
                color: color.primary_dark,
                padding: "24px",
              }}
            >
              {certCategory.name}
            </Typography>
            {certCategory.digital_performance && (
              <Typography
                sx={{
                  color: color.primary_dark,
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  opacity: 0.6,
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 1,
                    textDecoration: "underline",
                    textDecorationColor: "orange",
                  },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {t("digital_performance")}
                <PolicyIcon
                  fontSize="small"
                  sx={{
                    color: color.accent,
                    marginLeft: 1,
                  }}
                />
              </Typography>
            )}
          </Grid>
          {certCategory.knowledge_bases.length > 0 && (
            <Grid item xs={12}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: color.primary_dark,
                  fontWeight: "bold",
                }}
              >
                {t("knowledge_bases")}
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                {certCategory.knowledge_bases?.map((kb, index) => (
                  <Chip
                    key={index}
                    sx={{
                      color: color.primary_dark,
                      backgroundColor: color.accent,
                      fontWeight: "bold",
                    }}
                    label={kb.name}
                    variant="outlined"
                  />
                ))}
              </Box>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: color.accent,
            color: color.white,
            marginBottom: "10px",
            marginTop: "10px",
            marginRight: "10px",
            "&:hover": {
              backgroundColor: color.primary_dark,
              color: color.accent,
            },
          }}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CertCategoryModal;
